import { RestSchemas } from '@/contexts/QueryProvider'
import { ENDPOINTS } from '@/util'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useInvalidateDataAssetActivityLogByIds } from '../useGetDataAssetActivityLogByIds'
// import { useInvalidateTemplatesSummary } from '../../useGetTemplatesSummary'
// import { useInvalidateActivityLogByKeys } from '@/catalog-apps/components/component-library/DataTableComponent/RowActions/useGetActivityLogByKeys'

type TransitionUpdateResponse = RestSchemas['Messages.DataAssets.TDataAssetActivity']

const postTransitionUpdate = async (formData: FormData) => {
  const token = JSON.parse(sessionStorage.getItem('token') || '')
  const response = await fetch(`${ENDPOINTS.LANDING}/data_asset/transition`, {
    // Change to data assets
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return (await response.json()) as TransitionUpdateResponse
}

export function usePostTransitionUpdate({
  entityId,
  dataAssetId,
  onSuccess,
}: {
  entityId: number
  dataAssetId: number
  onSuccess?: () => void
}) {
  const invalidateActivityLogByIds = useInvalidateDataAssetActivityLogByIds({ entityId, dataAssetId })
  // const invalidateActivityLogByKeys = useInvalidateActivityLogByKeys()
  // const invalidateTemplatesSummary = useInvalidateTemplatesSummary()
  return useMutation({
    mutationFn: (variables: { formData: FormData }) => postTransitionUpdate(variables.formData),
    onSuccess: (_data) => {
      invalidateActivityLogByIds()
      // invalidateActivityLogByKeys()
      // invalidateTemplatesSummary()
      toast.success('Success')
      onSuccess?.()
    },
  })
}
